import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Tab, Tabs, Row, Col } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { MultiSelect } from 'react-multi-select-component';

import Trash from "../../../assets/images/delete.svg";
import edit from "../../../assets/images/pen.png";
import Arcv from "../../../assets/images/archive.svg";
import Active from "../../../assets/images/active.svg";
import { toast } from 'react-toastify';
import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faLink } from '@fortawesome/free-solid-svg-icons';

import { withoutRFSToken, withRFSToken, } from '../../../Services/axios.js';
import { STATIONS, ADDSTATION, STATIONGRID, ARCSTATIONGRID, ACTSTATIONGRID, REMSTATIONGRID, AIRLINESTATION, AIRLINESTATIONADD, AIRLINEACTARC } from '../../../Utils/conts.js';

const ShipmentRecordSettings = () => {
    const isMounted = useRef(false);
    const [dropdownData, setDropdownData] = useState([]);

    const [selectedValues, setSelectedValues] = useState([]);


    const handleSelect = (values) => {
        setSelectedValues(values);
    };
    // +++++++++++++++++++++++++++++++ Multiselect dropdown

    const options = [
        { label: 'BRU', value: 'option1' },
        { label: 'CDG', value: 'option2' },
        { label: 'AMS', value: 'option3' },
        { label: 'FRA', value: 'option4' },
        { label: 'USA', value: 'option5' },
    ];

    const [selected, setSelected] = useState([]);
    const [activeTab, setActiveTab] = useState('Export');
    const [activeTabD, setActiveTabD] = useState('Export');
    const handleChange = (selected) => {
        setSelected(selected);
    };

    // +++++++++++++++++++++++++++++++ Multiselect dropdown

    const gridRef = useRef(null);

    const [gridData, setGridData] = useState({
        Export: [],
        Import: [],
        // Trash: []
    });
    const [gridDataD, setGridDataD] = useState({
        Export: [],
        Import: [],
        // Trash: []
    });

    const fetchDataGrids = async (tab) => {
        const Tab = tab == 'Export' ? 'export' : (tab == 'Import' ? 'import' : 'export')
        try {
            const res = await withRFSToken.get(`shipment/get-settings?tab=${Tab}&type=S`, {})
                .then(function (res) {
                    const innerData = res.data.Rows;
                    // setGridData(innerData);
                    if (tab == 'Export') {
                        setGridData({ Export: innerData })
                    } else if (tab == 'Import') {
                        setGridData({ Import: innerData })
                    } else {
                        setGridData({ Export: innerData })
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataGrid = async (tab) => {
        const Tab = tab == 'Export' ? 'export' : (tab == 'Import' ? 'import' : 'export')
        try {
            const res = await withRFSToken.get(`shipment/get-settings?tab=${Tab}&type=D`, {})
                .then(function (res) {
                    const innerData = res.data.Rows;
                    // setGridData(innerData);
                    if (tab == 'Export') {
                        setGridDataD({ Export: innerData })
                    } else if (tab == 'Import') {
                        setGridDataD({ Import: innerData })
                    } else {
                        setGridDataD({ Export: innerData })
                    }

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchStatusOptions = async (tab) => {
        const Tab = tab || (activeTabD == 'Export' ? 'export' : 'import');
        try {
            const res = await withRFSToken.get(`shipment/get-settings?tab=${Tab}&type=S`, {})
                .then(function (res) {
                    const innerData = res.data.Rows || [];
                    const options = innerData.map(item => ({
                        value: item.id,
                        label: item.name
                    }));
                    setStatusOptions(options);
                });
        } catch (error) {
            console.error('Error fetching status options:', error);
            setStatusOptions([]);
        }
    };
    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        fetchDataGrids(activeTab);
        fetchDataGrid(activeTabD);
        isMounted.current = true;
    }, []);



    const [modalShow, setModalShow] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [modalSection, setModalSection] = useState('');
    const [actionType, setActionType] = useState('');

    const [gridSelect, setGridSelect] = useState([]);

    const [formData, setFormData] = useState({});
    const [statusOptions, setStatusOptions] = useState([]);

    const colors = [
        { value: 'Grey', label: 'Grey', color: "#808080" },
        { value: 'Red', label: 'Red', color: "#e53939" },
        { value: 'Orange', label: 'Orange', color: "#FFA500" },
        { value: 'Green', label: 'Green', color: "#008000" },
    ];

    const gridRefs = {
        Export: useRef(null),
        Import: useRef(null),
        // Trash: useRef(null),
    };
    const gridRefd = {
        Export: useRef(null),
        Import: useRef(null),
        // Trash: useRef(null),
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        if (activeTab !== tab) {
            fetchDataGrids(tab);
        }
    };
    const handleTabChangeD = (tab) => {
        setActiveTabD(tab);
        if (activeTabD !== tab) {
            fetchDataGrid(tab);
        }
    };

    const handleDetailsBackClick = (rowData) => {
        // setSelectedRowData(rowData);
        setShowDetails(false);
    };

    const handleAddButtonClick = (pos, actn) => {
        if (actn === 'add') {
            if (!formData.color) {
                setFormData((prev) => ({ ...prev, color: colors[0].value }));
            }
        }
        setModalSection(pos);
        setActionType(actn);
        setModalShow(true);
        // Fetch status options when opening Department modal
        if (pos === 'D') {
            fetchStatusOptions(formData.process);
        }
    };

    const handleModalClose = () => {
        setModalShow(false);
        setFormData({})
    };

    const handleFormOnchange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData((prevData) => ({
                ...prevData,
                [name]: checked
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value
            }));
            // Refetch status options when process changes in Department modal
            if (name === 'process' && modalSection === 'D') {
                fetchStatusOptions(value);
            }
        }
    }

    const handleAddToGrid = async () => {
        // let payload = {};
        // if (formData.id) {
        //     payload = {
        //         id: formData.id,
        //         type: modalSection,
        //         process: formData.process,
        //         name: formData.name,
        //         color: formData.color,
        //         description: formData.description,
        //         action_type: actionType,
        //         is_default: formData.is_default === true ? 1 : 0,
        //     }
        // } else {
        //     payload = {
        //         type: modalSection,
        //         process: formData.process,
        //         name: formData.name,
        //         color: formData.color,
        //         description: formData.description,
        //         action_type: actionType,
        //         is_default: formData.is_default === true ? 1 : 0,
        //     }
        // }
        const transformedData = {
            ...formData,
            is_default: formData.is_default ? 1 : 0,
            type: modalSection,
            action_type: actionType,
            // ...(actionType !== "update" && { type: modalSection }) 
        };

        try {
            const res = await withRFSToken.post('shipment/save-record-setting', transformedData)
                .then(function (res) {
                    // const innerData = res;
                    console.log("🚀 ~ .then ~ innerData:", res)
                    if (res.data.response_code == 200) {
                        toast.success('Station Added Successfully');
                        fetchDataGrid(activeTabD)
                        fetchDataGrids(activeTab);
                        // if (modalSection === 'S') {
                        //     fetchDataGrids(activeTab);
                        // } else {
                        //     fetchDataGrid(activeTabD)
                        // }
                        setFormData({})
                        setModalShow(false);
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    };

    const handleDeleteGrid = async () => {
        const transformedData = {
            ...formData,
            is_default: formData.is_default ? 1 : 0,
            type: modalSection,
            action_type: actionType,
            // ...(actionType !== "update" && { type: modalSection }) 
        };

        try {
            const res = await withRFSToken.get(`shipment/delete-settings/${formData.id}`,)
                .then(function (res) {
                    // const innerData = res;
                    console.log("🚀 ~ .then ~ innerData:", res)
                    if (res.data.response_code == 200) {
                        toast.success('Station Added Successfully');
                        fetchDataGrids(activeTab);
                        fetchDataGrid(activeTabD)
                        // if (modalSection === 'S') {
                        //     fetchDataGrids(activeTab);
                        // } else {
                        //     fetchDataGrid(activeTabD)
                        // }
                        setFormData({})
                        setActArcModal(false)
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }

    };


    const colorMap = {
        grey: "#808080",
        red: "#e53939",
        orange: "#FFA500",
        green: "#008000"
    };
    // console.log('grid-data', gridData)
    // console.log('mm')
    // console.log("🚀 ~ localData ~ localData:", gridData[activeTab])
    // console.log("🚀 ~ localData ~ Active:", activeTab)
    let checkUlds = [];
    useEffect(() => {

        if (gridRefs[activeTab].current && !showDetails) {

            if (gridData[activeTab]) {
                const localData = gridData[activeTab]
                // ? gridData[activeTab].map(item => ({

                //     id: item.id,
                //     STN: item.station_code,
                //     Taddrs: item?.station_addresses?.length,
                //     Address: item?.station_addresses, // ?.join(', ')Join the address array into a string
                //     user_count: item?.Usercount
                // })) : [{ id: '', STN: '', }];
                // console.log("🚀 ~ localData ~ localData:", localData)
                const source = {
                    datatype: 'json',
                    id: `${activeTab}-`,
                    datafields: [
                        { name: 'id', type: 'string' },
                        { name: 'name', type: 'string' },
                        { name: 'description', type: 'string' },
                        { name: 'department_are', type: 'string' },
                        { name: 'color', type: 'string' },
                        { name: 'process', type: 'string' },
                        { name: 'is_default', type: 'string' },
                        // { name: 'user_count', type: 'string' },
                    ],
                    localdata: localData,
                };

                const dataAdapter = new window.$.jqx.dataAdapter(source);
                // console.log('localdata', source.localdata)
                const columns = [
                    // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
                    { text: 'Name', filtertype: 'textbox', datafield: 'name', width: '20%', cellclassname: 'frcl', },
                    // { text: 'Description', filtertype: 'textbox', datafield: 'description', width: '20%', cellclassname: 'frcl', },
                    {
                        text: 'Department', filtertype: 'textbox', datafield: 'department_are', width: '40%', cellclassname: 'frcl',
                        cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                            const dname = rowData?.department_are?.map(d => d.name)
                            return `<div style="margin-left:10px; margin-top:13px; cursor: pointer;" class="sec-status-cell">${dname}</div>`;
                        },
                    },
                    {
                        text: 'Color', filtertype: 'textbox', datafield: 'color', width: '18%', cellclassname: 'frcl',
                        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata, cellValue) {
                            const colorCode = colorMap[rowdata.color.toLowerCase()] || "#000";
                            // console.log('cellValue', rowdata);

                            return `<div class="jqx-grid-cell-left-align" style="margin:13px 0 0 10px; display: flex; align-items: center;"><span style="
                        height: 10px;
                        width: 10px;
                        border-radius: 50%;
                        background-color: ${colorCode};
                        display: inline-block;
                        margin-right: 7px;">
                    </span>
                    ${rowdata.color}
                </div>`;
                        },
                    },
                    {
                        text: 'Actions',
                        cellsrenderer: function () {
                            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /> <img src="' + Trash + '" class="row_delete" /></div>';
                        },
                        width: '12%', filterable: false,
                    },
                ];

                const gridOptions = {
                    width: '100%',
                    source: dataAdapter,
                    columns: columns,
                    autoheight: true,
                    sortable: true,
                    altrows: false,
                    enabletooltips: true,
                    editable: false,
                    selectionmode: 'checkbox',
                    pageable: false,
                    pageSize: 10,
                    pagerButtonsCount: 5,
                    pagerMode: 'advanced',
                    filterable: true,
                    filterrowheight: 45,
                    showfilterrow: true,
                    rowsheight: 42,
                    columnsheight: 45,

                };

                window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
                window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');

                window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                    const rowDiv = window.$(this).closest('[role="row"]');

                    const rowIndex = window.$(rowDiv).attr('row-id');
                    const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);
                    if (boundIndex !== undefined) {
                        const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                        const pageIndex = pagingInfo.pagenum;
                        const pageSize = pagingInfo.pagesize;
                        const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                        // console.log('Global Index:', globalIndex); 
                        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                        console.log('Global Index:', rowData);
                        if (rowData) {
                            const transData = {
                                color: rowData.color,
                                description: rowData.description,
                                id: rowData.id,
                                is_default: rowData.is_default === 0 ? false : true,
                                name: rowData.name,
                                process: rowData.process,
                                // type: rowData.type
                            }
                            setFormData(transData);
                            handleAddButtonClick('S', 'update')
                            // setActionType('update')
                            // setModalShow(true);

                        } else {
                            console.error('No data found for the given row index.');
                        }
                    } else {
                        console.error('Bound index could not be retrieved. Check the row index and data binding.');
                    }
                });
                window.$(gridRefs[activeTab].current).on('click', '.row_delete', function () {
                    const rowDiv = window.$(this).closest('[role="row"]');

                    const rowIndex = window.$(rowDiv).attr('row-id');
                    const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);
                    if (boundIndex !== undefined) {
                        const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                        const pageIndex = pagingInfo.pagenum;
                        const pageSize = pagingInfo.pagesize;
                        const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                        // console.log('Global Index:', globalIndex); 
                        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                        console.log('Global Index:', rowData);
                        if (rowData) {
                            const transData = {
                                // color: rowData.color,
                                // description: rowData.description,
                                id: rowData.id,
                                // is_default: rowData.is_default === 0 ? false : true,
                                // name: rowData.name,
                                // process: rowData.process,
                                // type: rowData.type
                            }
                            setFormData(transData);
                            // handleAddButtonClick('S', 'delete');
                            setModalSection('S')
                            setActArcModal(true)
                            setActionType('delete')
                            // setModalShow(true);

                        } else {
                            console.error('No data found for the given row index.');
                        }
                    } else {
                        console.error('Bound index could not be retrieved. Check the row index and data binding.');
                    }
                });
                window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                    window.$(row).on('mouseover', () => {
                        window.$(row).addClass('row-hover');
                    });
                    window.$(row).on('mouseout', () => {
                        window.$(row).removeClass('row-hover');
                    });
                });
                // row selection by checkbox
                window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                    if (event.args.row) {
                        const selectedRow = event.args.row;
                        const uldNumber = selectedRow.uld_number;
                        const selectedRowId = selectedRow.uid;
                        if (!checkUlds.includes(uldNumber)) {
                            checkUlds.push(uldNumber);
                        }
                        // console.log(checkUlds);
                        // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                        //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                        // }
                        setGridSelect(prevGridSelect => {
                            if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
                                return [...prevGridSelect, selectedRow];
                            }
                            return prevGridSelect;
                        });
                    } else {
                        if (event.args.rowindex.length > 0) {
                            const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                            setGridSelect(allIds);
                        } else {
                            setGridSelect([]);
                        }
                    }
                });
                window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                    if (event.args.row) {
                        const unselectedRowId = event.args.row.uld_number;
                        setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
                        // if(filterForCheck!=true){
                        if (!checkUlds.includes(unselectedRowId)) {
                            checkUlds.push(unselectedRowId);
                        } else {
                            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                        }
                        // }
                        // console.log(checkUlds);

                    }
                });
                // End row selection 

            } else {
                const columns = [
                    { text: 'Stations', filtertype: 'textbox', datafield: 'STN', width: '50%' },
                    { text: 'Status', filtertype: 'textbox', datafield: 'status', width: '50%' },
                    { text: 'Total Address', filtertype: 'textbox', datafield: 'Taddrs', width: '50%' },
                ];
            }
        }
    }, [activeTab, gridData, showDetails]);

    let checkUldd = [];
    useEffect(() => {

        if (gridRefd[activeTabD].current) {

            if (gridDataD[activeTabD]) {
                const localData = gridDataD[activeTabD]
                // ? gridData[activeTabD].map(item => ({

                //     id: item.id,
                //     STN: item.station_code,
                //     Taddrs: item?.station_addresses?.length,
                //     Address: item?.station_addresses, // ?.join(', ')Join the address array into a string
                //     user_count: item?.Usercount
                // })) : [{ id: '', STN: '', }];
                // console.log("🚀 ~ localData ~ localData:", localData)
                const source = {
                    datatype: 'json',
                    id: `${activeTabD}-`,
                    datafields: [
                        { name: 'id', type: 'string' },
                        { name: 'name', type: 'string' },
                        { name: 'description', type: 'string' },
                        // { name: 'color', type: 'string' },
                        { name: 'process', type: 'string' },
                        { name: 'status_are', type: 'string' },
                    ],
                    localdata: localData,
                };

                const dataAdapter = new window.$.jqx.dataAdapter(source);
                // console.log('localdata', source.localdata)
                const columns = [
                    // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
                    { text: 'Name', filtertype: 'textbox', datafield: 'name', width: '80%', cellclassname: 'frcl', },
                    // { text: 'Description', filtertype: 'textbox', datafield: 'description', width: '40%', cellclassname: 'frcl', },
                    // { text: 'Color', filtertype: 'textbox', datafield: 'color', width: '18%', cellclassname: 'frcl', },
                    {
                        text: 'Actions',
                        cellsrenderer: function () {
                            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /> <img src="' + Trash + '" class="row_delete" /></div>';
                        },
                        width: '12%', filterable: false,
                    },
                ];

                const gridOptions = {
                    width: '100%',
                    source: dataAdapter,
                    columns: columns,
                    autoheight: true,
                    sortable: true,
                    altrows: false,
                    enabletooltips: true,
                    editable: false,
                    selectionmode: 'checkbox',
                    pageable: false,
                    pageSize: 10,
                    pagerButtonsCount: 5,
                    pagerMode: 'advanced',
                    filterable: true,
                    filterrowheight: 45,
                    showfilterrow: true,
                    rowsheight: 42,
                    columnsheight: 45,

                };

                window.$(gridRefd[activeTabD].current).jqxGrid(gridOptions);
                window.$(gridRefd[activeTabD].current).find('.jqx-grid-column-header').css('background-color', 'white');

                window.$(gridRefd[activeTabD].current).on('click', '.row_edit', function () {
                    const rowDiv = window.$(this).closest('[role="row"]');
                    console.log('Global Index:', rowDiv);
                    const rowIndex = window.$(rowDiv).attr('row-id');
                    const boundIndex = window.$(gridRefd[activeTabD].current).jqxGrid('getrowid', rowIndex);
                    if (boundIndex !== undefined) {
                        const pagingInfo = window.$(gridRefd[activeTabD].current).jqxGrid('getpaginginformation');
                        const pageIndex = pagingInfo.pagenum;
                        const pageSize = pagingInfo.pagesize;
                        const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                        // console.log('Global Index:', globalIndex); 
                        const rowData = window.$(gridRefd[activeTabD].current).jqxGrid('getrowdata', globalIndex);
                        if (rowData) {
                            const statusId = rowData.status_are?.map(st => st.id)
                            // console.log('Global statusId:', statusId); 
                            const transData = {
                                // color: rowData.color,
                                description: rowData.description,
                                id: rowData.id,
                                // is_default: rowData.is_default === 0 ? false : true,
                                name: rowData.name,
                                process: rowData.process,
                                status_id: statusId || [],
                                // type: rowData.type
                            }
                            setFormData(transData);
                            handleAddButtonClick('D', 'update')

                        } else {
                            console.error('No data found for the given row index.');
                        }
                    } else {
                        console.error('Bound index could not be retrieved. Check the row index and data binding.');
                    }
                });
                window.$(gridRefd[activeTabD].current).on('click', '.row_delete', function () {
                    const rowDiv = window.$(this).closest('[role="row"]');

                    const rowIndex = window.$(rowDiv).attr('row-id');
                    const boundIndex = window.$(gridRefd[activeTabD].current).jqxGrid('getrowid', rowIndex);
                    if (boundIndex !== undefined) {
                        const pagingInfo = window.$(gridRefd[activeTabD].current).jqxGrid('getpaginginformation');
                        const pageIndex = pagingInfo.pagenum;
                        const pageSize = pagingInfo.pagesize;
                        const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                        // console.log('Global Index:', globalIndex); 
                        const rowData = window.$(gridRefd[activeTabD].current).jqxGrid('getrowdata', globalIndex);
                        console.log('Global Index:', rowData);
                        if (rowData) {
                            const transData = {
                                // color: rowData.color,
                                // description: rowData.description,
                                id: rowData.id,
                                // is_default: rowData.is_default === 0 ? false : true,
                                // name: rowData.name,
                                // process: rowData.process,
                                // type: rowData.type
                            }
                            setFormData(transData);
                            // handleAddButtonClick('S', 'delete');
                            setModalSection('D')
                            setActArcModal(true)
                            setActionType('delete')
                            // setModalShow(true);

                        } else {
                            console.error('No data found for the given row index.');
                        }
                    } else {
                        console.error('Bound index could not be retrieved. Check the row index and data binding.');
                    }
                });
                window.$(gridRefd[activeTabD].current).find('div[role="row"]').each((index, row) => {
                    window.$(row).on('mouseover', () => {
                        window.$(row).addClass('row-hover');
                    });
                    window.$(row).on('mouseout', () => {
                        window.$(row).removeClass('row-hover');
                    });
                });
                // row selection by checkbox
                window.$(gridRefd[activeTabD].current).on('rowselect', (event) => {
                    if (event.args.row) {
                        const selectedRow = event.args.row;
                        const uldNumber = selectedRow.uld_number;
                        const selectedRowId = selectedRow.uid;
                        if (!checkUldd.includes(uldNumber)) {
                            checkUldd.push(uldNumber);
                        }
                        // console.log(checkUldd);
                        // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                        //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                        // }
                        setGridSelect(prevGridSelect => {
                            if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
                                return [...prevGridSelect, selectedRow];
                            }
                            return prevGridSelect;
                        });
                    } else {
                        if (event.args.rowindex.length > 0) {
                            const allIds = window.$(gridRefd[activeTabD].current).jqxGrid('getrows');
                            setGridSelect(allIds);
                        } else {
                            setGridSelect([]);
                        }
                    }
                });
                window.$(gridRefd[activeTabD].current).on('rowunselect', (event) => {
                    if (event.args.row) {
                        const unselectedRowId = event.args.row.uld_number;
                        setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
                        // if(filterForCheck!=true){
                        if (!checkUldd.includes(unselectedRowId)) {
                            checkUldd.push(unselectedRowId);
                        } else {
                            checkUldd = checkUldd.filter(item => item !== unselectedRowId);
                        }
                        // }
                        // console.log(checkUldd);

                    }
                });
                // End row selection 

            } else {
                const columns = [
                    { text: 'Stations', filtertype: 'textbox', datafield: 'STN', width: '50%' },
                    { text: 'Total Address', filtertype: 'textbox', datafield: 'Taddrs', width: '50%' },
                ];
            }
        }
    }, [activeTabD, gridDataD]);
    // row click function start
    const handleArchiveButtonClick = () => {
        archiveSelectedRows(gridSelect);
    };

    const [actArcModal, setActArcModal] = useState(false);
    const handleMoveToActArc = () => {
        if (gridSelect.length <= 0) {
            toast.error('Please select grid data before send');
        } else {
            setActArcModal(true);
            // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
        }
    };
    const confirmMoveToActArc = async () => {
        // console.log('101', gridSelect);
        const sendAction = activeTab == 'Active' ? 'I' : 'A';
        const uldNumbers = gridSelect && gridSelect.map(num => num.STN)
        try {
            const res = await withRFSToken.post(AIRLINEACTARC, { station_code: uldNumbers, status: sendAction })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success('Moved Successfully')
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([]);
                        fetchDataGrid(activeTab)
                        // if (activeTab == 'Active') {
                        //     toast.success('ULD Data moved to Arhive');
                        //     fetchDataGrid()
                        // } else {
                        //     toast.success('ULD Data moved to Active');
                        //     // fetchDataGridR()
                        // }
                        setActArcModal(false)
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const archiveSelectedRows = async (selectedIds) => {
        // Perform deletion logic here using the selected IDs
        console.log("Archive selected IDs:", selectedIds);
        const uniqueIds = Array.from(new Set(selectedIds));
        // Now you can send the selected IDs to your API or perform any other action
        if (selectedIds.length > 0) {
            // dispatch(addStationArchiveData(selectedIds)); // Pass sendStationData to addData thunk
            try {

                // Make API call here await withToken.post(SUBMIT_SHIPMENT_FORM, {formData});
                // Example:
                const response = await withRFSToken.post(ARCSTATIONGRID, { truck_stations: uniqueIds });
                console.log("🚀 ~ addData ~ response:", response)
                if (!response.ok) {
                    throw new Error('Failed to add data');
                }
                // dispatch(addDataSuccess(data));
                // dispatch(fetchStationGridData());
                // reloadGrid();
            } catch (error) {
                // dispatch(addDataFailure(error.message));
                console.error('Error fetching data:', error);
            }
        }
        window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedIds);
        window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
        // dispatch(fetchStationGridData());
        // reloadGrid();
    };

    const handleActiveButtonClick = () => {
        activeSelectedRows(gridSelect);
    };
    const activeSelectedRows = async (selectedIds) => {
        // Perform deletion logic here using the selected IDs
        console.log("Archive selected IDs:", selectedIds);
        const uniqueIds = Array.from(new Set(selectedIds));
        // Now you can send the selected IDs to your API or perform any other action
        if (selectedIds.length > 0) {
            // dispatch(addStationArchiveData(selectedIds)); // Pass sendStationData to addData thunk
            try {

                // Make API call here await withToken.post(SUBMIT_SHIPMENT_FORM, {formData});
                // Example:
                const response = await withRFSToken.post(ACTSTATIONGRID, { truck_stations: uniqueIds });
                console.log("🚀 ~ addData ~ response:", response)
                if (!response.ok) {
                    throw new Error('Failed to add data');
                }
                // dispatch(addDataSuccess(data));
                // dispatch(fetchStationGridData());
                // reloadGrid();
            } catch (error) {
                // dispatch(addDataFailure(error.message));
                console.error('Error fetching data:', error);
            }
        }
        window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedIds);
        window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
        // dispatch(fetchStationGridData());
        // reloadGrid();
    };

    const handleDeleteButtonClick = () => {
        deleteSelectedRows(gridSelect);
        // if (gridSelect){
        //   handleShowConfirmation(deleteSelectedRows);
        // }
    };
    const deleteSelectedRows = async (selectedIds) => {
        // Perform deletion logic here using the selected IDs
        console.log("Archive selected IDs:", selectedIds);
        const uniqueIds = Array.from(new Set(selectedIds));
        // Now you can send the selected IDs to your API or perform any other action
        if (selectedIds.length > 0) {
            // dispatch(addStationRemoveData(selectedIds)); // Pass sendStationData to addData thunk
            try {

                // Make API call here await withToken.post(SUBMIT_SHIPMENT_FORM, {formData});
                // Example:
                const response = await withRFSToken.post(REMSTATIONGRID, { truck_stations: uniqueIds });
                console.log("🚀 ~ addData ~ response:", response)
                if (!response.ok) {
                    throw new Error('Failed to add data');
                }
                // dispatch(addDataSuccess(data));
                // dispatch(fetchStationGridData());
                // reloadGrid();
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedIds);
        window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
        // dispatch(fetchStationGridData());
        // reloadGrid();
    };


    // const reloadGrid = async () => {
    //   try {
    //     const res = await withRFSToken.post(STATIONGRID, {})
    //       .then(function (res) {
    //         const innerData = res.data.response_data;
    //         setGridData(innerData);
    //       });

    //   } catch (error) {
    //     console.error('Error fetching data:', error);
    //   }
    // };

    const SBack = localStorage.getItem('SettingsBack');

    return (
        <>
            {/* <div className="">{console.log('formData', formData)} */}
                {/* <Header page_type='fsm' logo_url='/ForwarderShipments/Export' /> */}
                {/* <Header page_type='fsm' logo_url={SBack ? SBack : '/ForwarderShipments/Export'} sBackUrl={SBack ? SBack : '/ForwarderShipments/Export'} />
                <div className="main-panel">
                    <div className="row">
                        <LeftSettings /> */}
                        <div className='col-9 col-xxl-9 stting_right'>
                            <div className='settingbg_right'>
                                {!showDetails &&
                                    <>
                                        <h4>Shipment Record Settings</h4>
                                        <p>Set your notification preferences for when you are in or away from the dashboard.</p>

                                        <div className='row'>
                                            <div className='col-6 pe-5 brd_rgt'>
                                                <div className='d-flex justify-content-between fsm_seting'>
                                                    <div>
                                                        <h4>Status</h4>
                                                        <p>Statuses are available for the shipment records</p>
                                                    </div>

                                                    <Button variant="link add_adres" onClick={() => handleAddButtonClick('S', 'add')}>
                                                        <FontAwesomeIcon icon={faPlus} /> Add
                                                    </Button>
                                                </div>
                                                <Tabs defaultActiveKey={activeTab} onSelect={(tab) => handleTabChange(tab)} id="station-tabs" className="station_grid">
                                                    <Tab eventKey="Export" title={<span>Export</span>} className='moveto'>
                                                        {/* <div className='moveto_btn'>
                                                            <button onClick={handleMoveToActArc}> <img src={Arcv} /></button>
                                                        </div> */}
                                                        <div ref={gridRefs.Export} className='staion_grid' ></div>
                                                    </Tab>
                                                    <Tab eventKey="Import" title={<span>Import</span>} className='moveto'>
                                                        {/* <div className='moveto_btn'>
                                                            <button onClick={handleMoveToActArc}> <img title='' src={Active} /></button>
                                                        </div> */}
                                                        <div ref={gridRefs.Import} className='staion_grid' ></div>
                                                    </Tab>
                                                </Tabs>
                                            </div>
                                            <div className='col-6 ps-5'>

                                                <div className='d-flex justify-content-between fsm_seting'>
                                                    <div>
                                                        <h4>Department</h4>
                                                        <p>Add departments creation of a shipment record,</p>
                                                    </div>

                                                    <Button variant="link add_adres" onClick={() => handleAddButtonClick('D', 'add')}>
                                                        <FontAwesomeIcon icon={faPlus} /> Add
                                                    </Button>
                                                </div>
                                                <Tabs defaultActiveKey={activeTabD} onSelect={(tab) => handleTabChangeD(tab)} id="station-tabs" className="station_grid">
                                                    <Tab eventKey="Export" title={<span>Export</span>} className='moveto'>
                                                        <div ref={gridRefd.Export} className='staion_grid' ></div>
                                                    </Tab>
                                                    <Tab eventKey="Import" title={<span>Import</span>} className='moveto'>
                                                        <div ref={gridRefd.Import} className='staion_grid' ></div>
                                                    </Tab>
                                                </Tabs>
                                            </div>
                                        </div>

                                        <Modal show={modalShow} centered onHide={handleModalClose} className='addfrom' >
                                            <Modal.Header closeButton>
                                                <Modal.Title>{actionType === 'add' ? 'Add' : 'Edit'} {modalSection === 'S' ? 'Status' : 'Department'}</Modal.Title>
                                                {/* <p>Add stations by selecting the station.</p> */}
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className="mb-2">
                                                    <Form.Check
                                                        inline
                                                        label="Export"
                                                        name="process"
                                                        type='radio'
                                                        id='export'
                                                        value='export'
                                                        checked={formData.process === 'export'}
                                                        onChange={handleFormOnchange}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="Import"
                                                        value="import"
                                                        name="process"
                                                        type='radio'
                                                        id='import'
                                                        checked={formData.process === 'import'}
                                                        onChange={handleFormOnchange}
                                                    />
                                                </div>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>{modalSection === 'S' ? 'Status' : 'Department'} name <span>*</span></Form.Label>
                                                    <Form.Control placeholder={modalSection === 'S' ? 'Status Name' : 'Department Name'} onChange={handleFormOnchange} name='name' value={formData.name || ''} />
                                                </Form.Group>
                                                {modalSection === 'D' &&
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Status</Form.Label>
                                                        <Select
                                                            options={statusOptions}
                                                            isMulti
                                                            placeholder="--"
                                                            className="autoslct w-100"
                                                            value={statusOptions.filter(option => formData.status_id?.includes(option.value))}
                                                            onChange={(selected) => {
                                                                const statusIds = selected ? selected.map(item => item.value) : [];
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    status_id: statusIds
                                                                }));
                                                            }}
                                                        />
                                                    </Form.Group>
                                                }
                                                {modalSection === 'S' &&
                                                    <>
                                                        <Form.Group className="mb-2 align-items-center" as={Row}>
                                                            <Form.Label>Status Color </Form.Label> {/* > */}
                                                            <Col sm={7}>
                                                                <Select
                                                                    options={colors}
                                                                    onChange={(selected) => {
                                                                        setFormData({
                                                                            ...formData,
                                                                            color: selected.value
                                                                        });
                                                                    }}
                                                                    // placeholder="Status Color"
                                                                    className='rfs_autoslct'
                                                                    name="color"
                                                                    value={formData.color
                                                                        ? colors.find(option => option.value === formData.color)
                                                                        : null}
                                                                    getOptionLabel={(e) => (
                                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                                            <span
                                                                                style={{
                                                                                    height: "12px",
                                                                                    width: "12px",
                                                                                    borderRadius: "50%",
                                                                                    backgroundColor: e.color,
                                                                                    display: "inline-block",
                                                                                    marginRight: "10px",
                                                                                }}
                                                                            />
                                                                            {e.label}
                                                                        </div>
                                                                    )}
                                                                />
                                                            </Col>
                                                            <Col sm={5}>
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    id="disabledFieldsetCheck"
                                                                    name='is_default'
                                                                    label="Is Default"
                                                                    onChange={handleFormOnchange}
                                                                    checked={formData.is_default || false}
                                                                />
                                                            </Col>
                                                        </Form.Group>

                                                        <Form.Group className="">
                                                            <Form.Label>Description</Form.Label>
                                                            <Form.Control placeholder="Description" name='description' onChange={handleFormOnchange} value={formData.description || ''} />
                                                        </Form.Group>
                                                    </>
                                                }
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="primary" onClick={handleAddToGrid}>
                                                    {actionType === 'add' ? 'Add' : 'Update'} {modalSection === 'S' ? 'Status' : 'Department'}
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                    </>
                                }
                                <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered>
                                    <Modal.Header closeButton>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <h3>Selected {modalSection === 'S' ? 'Status' : 'Department'} will be removed</h3>
                                        <p>Are you sure you want to remove {modalSection === 'S' ? 'Status' : 'Department'}?</p>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <div className='d-flex w-50 mx-auto are_bottom'>
                                            <Button variant="secondary" onClick={() => setActArcModal(false)}>
                                                No
                                            </Button>
                                            <Button variant="primary" onClick={handleDeleteGrid}>
                                                Yes
                                            </Button>
                                        </div>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                        </div>
                    {/* </div>
                </div>
            </div> */}
        </>
    )
}

export default ShipmentRecordSettings
